var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 17.2",
    style: {
      enableBackground: "new 0 0 18 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#355D8B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11944",
    transform: "translate(-902 -527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    className: "st0",
    d: "M920,537.6c0-0.6-0.2-1.2-0.7-1.6c0.5-0.4,0.7-1,0.7-1.6c0-1-0.8-1.9-1.8-2c0,0-0.1,0-0.1,0 h-4.3v-2.7c0.1-1.5-1.1-2.7-2.5-2.7c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.2-0.4,0.4v3l-1.5,2.2l-1.7,1.3v-1c0-0.2-0.2-0.4-0.4-0.4h-4.7 c-0.2,0-0.4,0.2-0.4,0.4v11c0,0.2,0.2,0.4,0.4,0.4h4.7c0.2,0,0.4-0.2,0.4-0.4v-0.3c0.3,0.4,0.7,0.6,1.2,0.7h8.6 c0.6,0,1.2-0.2,1.6-0.7c0.6-0.7,0.7-1.7,0.2-2.5c0.5-0.1,0.9-0.5,0.9-1.1c0-0.5-0.2-1-0.5-1.4C919.8,538.3,920,538,920,537.6z  M906.7,543.4h-3.9v-10.2h3.9V543.4z M917.3,538c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h0.8c0.6,0,1.1,0.4,1.2,1.1 c0,0,0,0.1,0,0.1c0,0.3-0.2,0.4-1.2,0.4h-1.6c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h1.6c0.4,0,0.6,0.5,0.6,1 c0,0.3-0.1,0.7-0.3,0.9c-0.3,0.3-0.7,0.4-1.1,0.4h-8.6c-0.3,0-0.9-0.7-1.2-1.3v-7.3l2.2-1.6c0,0,0.1-0.1,0.1-0.1l1.6-2.3 c0-0.1,0.1-0.1,0.1-0.2v-2.7c0.9,0.1,1.6,1,1.6,1.9v3.1c0,0.2,0.2,0.4,0.4,0.4h4.7c0.6,0,1.2,0.5,1.2,1.1c0,0.6-0.5,1.2-1.1,1.2 c0,0,0,0-0.1,0h-1.3c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4c0,0,0,0,0,0h1.3c0.6,0,1.1,0.4,1.2,1.1c0,0,0,0.1,0,0.1 c0,0.3-0.2,0.4-1.2,0.4L917.3,538z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    className: "st0",
    d: "M904.7,542.3c0.4,0,0.8-0.3,0.8-0.7c0-0.4-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.7 C903.9,541.8,904.2,542.2,904.7,542.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.a93c1bba822d2e5438b17e1a407493ca.svg";
export { ForwardRef as ReactComponent };